import { useState } from "react";
import { visionURL } from "../config/environment";
import Jsona from "jsona";
import JsonApiService from "../services/jsonapiService";
import visionCallService from "../services/visionCallService";

const dataFormatter = new Jsona();

const policyDocumentsApiService = async () =>
  new JsonApiService("policy_documents", {
    baseUrl: `${visionURL}/admin_console/api/content`,
    credentials: "include"
  });

export const usePolicyDocuments = () => {
  const [isCreating, setIsCreating] = useState(false);
  const [isFetching, setIsFetching] = useState(false);
  const [isUpdating, setIsUpdating] = useState(false);

  const createPolicyDocument = async newPolicyDocumentData => {
    setIsCreating(true);
    const service = await policyDocumentsApiService();
    const response = await service
      .create(
        visionCallService.serializeRequestBody(
          newPolicyDocumentData,
          "policyDocument",
          ["courseSection"]
        )
      )
      .then(response => response.json());
    setIsCreating(false);
    if (response.errors) {
      throw response.errors;
    } else {
      return dataFormatter.deserialize(response);
    }
  };

  const updatePolicyDocument = async policyDocumentData => {
    setIsUpdating(true);
    const service = await policyDocumentsApiService();
    const response = await service
      .update(
        policyDocumentData.id,
        visionCallService.serializeRequestBody(
          policyDocumentData,
          "policyDocument"
        )
      )
      .then(response => response.json());
    setIsUpdating(false);
    if (response.errors) {
      throw response.errors;
    } else {
      return dataFormatter.deserialize(response);
    }
  };

  const findPolicyDocument = async ({ policyDocumentId, include }) => {
    setIsFetching(true);
    const service = await policyDocumentsApiService();
    const response = await service
      .include(include)
      .find(policyDocumentId)
      .then(response => response.json());
    setIsFetching(false);
    if (response.errors) {
      throw response.errors;
    } else {
      return dataFormatter.deserialize(response);
    }
  };

  return {
    createPolicyDocument,
    findPolicyDocument,
    updatePolicyDocument,
    isCreating,
    isFetching,
    isUpdating
  };
};
